import { Entities, Icon } from "@timesheets/webapp-support";

import { IState } from "../IState";
import { Module } from "vuex";

export const header: Module<Entities.IHeader, IState> = {
  namespaced: true,
  state: {
    title: null,
  },
  mutations: {
    title(state: Entities.IHeader, { faIcon, text }: { faIcon: Icon; text: string }) {
      const newTitle = {
        faIcon,
        text,
      };
      state.title = newTitle;
      document.title = newTitle.text;
    },
  },
};
